module.exports=function(scope){ return `curl -X POST \
'https://api.zoomauth.com/api/v2/biometrics/liveness' \
-H 'Content-Type: application/json' \
-H 'X-Device-License-Key: ${scope.appToken}' \
-H 'X-User-Agent: ZoomSDK.createZoomAPIUserAgentString(INSERT_SESSION_ID_FROM_zoomSessionResult)' \
-d '{
  "sessionId": INSERT_SESSION_ID_FROM_zoomSessionResult,
  "faceMap": INSERT_FACEMAP_FROM_zoomSessionResult,
  "auditTrailImage": INSERT_AUDIT_TRAIL_IMAGE_FROM_zoomSessionResult
  "lowQualityAuditTrailImage": INSERT_LOW_QUALITY_AUDIT_TRAIL_IMAGE_FROM_zoomSessionResult
}'
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/bash/liveness.bash.tpl